export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const TRANSPARENT_ON_PRIMARY = 'transparent-on-primary';
